import { Layout } from '@roc/feature-app-core';
import { EmbeddedFrameBoundaries } from '@roc/ui';
import { BorrowerInfoCardCustomTheme } from './components/borrowerInfoCardCustomTheme';
import { BorrowerInfoCardInternalStore } from './stores/borrowerInfoCardInternalStore';
import { BorrowerTrackRecordStore } from '@roc/feature-borrowers';
import { TrackRecordV2 } from '@roc/feature-track-record-v2';

const CLOSE_BUTTON_CLEARANCE = 24;
const TRACK_RECORD_MODAL_HEIGHT = Math.max(600, Math.round(window.screen.availHeight * 0.725) - 56);

export const BorrowerTrackRecordComponent = (store: BorrowerInfoCardInternalStore, trackRecordstore: BorrowerTrackRecordStore, borrowerId: string, loanId: string) => {
  // Every render of the routes hook calls this, so assign only when this route's params are actually present.
  if (!borrowerId) {
    return (<></>);
  }
  store.currentBorrower = parseInt(borrowerId);
  store.loanId = loanId;
  let parsedBorrowerId;
  let parsedLoanId;
  try {
    parsedBorrowerId = borrowerId ? parseInt(borrowerId) : null;
    parsedLoanId = loanId ? parseInt(loanId) : null;
  } catch { }

  if (parsedBorrowerId == null || Number.isNaN(parsedBorrowerId)) {
    return (<></>);
  }

  // Prime the baseball-card store (used by the v2 Borrower Experience block and by
  // the entity verify/unverify flow, which reads store.loanId).
  store.fetchBaseballCardData(parsedBorrowerId, parsedLoanId);

  const onClose = () => {
    // Target the embedding parent's origin explicitly instead of '*'.
    const parentOrigin = window.location.ancestorOrigins?.[0] || window.location.origin;
    window.parent.postMessage('saved-success', parentOrigin);
  };

  return (
    <Layout>
      <BorrowerInfoCardCustomTheme>
        <EmbeddedFrameBoundaries>
          <div style={{ paddingTop: CLOSE_BUTTON_CLEARANCE }}>
          <TrackRecordV2
            token=''
            isInternal={true}
            store={trackRecordstore}
            onClose={onClose}
            borrowerId={parsedBorrowerId}
            hideTaskTitle
            hideTabs
            // Borrower profile view: no task to accept, so no footer row.
            hideFooter
            // Must stay in px: a vh-based height shrinks the iframe on every resize message.
            maxHeight={TRACK_RECORD_MODAL_HEIGHT}
          />
          </div>
        </EmbeddedFrameBoundaries>
      </BorrowerInfoCardCustomTheme>
    </Layout>
  );
}
